export type OrganizerSort = 'DESC' | 'ASC' | 'SUBSCRIPTION_EXPIRING';

interface TournamentSortArgs {
  sortByCreatedAt?: string;
  sortBy?: string;
}

export function mapTournamentSort(sort?: string): TournamentSortArgs {
  if (sort === 'SUBSCRIPTION_EXPIRING') {
    return { sortBy: 'SUBSCRIPTION_EXPIRATION' };
  }

  return { sortByCreatedAt: sort === 'ASC' ? 'ASC' : 'DESC' };
}
